import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useInvestigationsUIContext } from "../InvestigationsUIContext";
import { fetchInvestigations } from "../../../_redux/investigations/investigationsActions";
import {
  ActionsColumnFormatter,
  DateColumnFormatter,
  NameLinkFormatter,
} from "./column-formatters/index";

import * as uiHelpers from "../InvestigationsUIHelpers";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../../_metronic/_helpers";

export function InvestigationsTable() {
  const { user } = useSelector((state) => state.auth);

  const investigationsUIContext = useInvestigationsUIContext();

  const investigationsUIProps = useMemo(() => {
    return {
      queryParams: investigationsUIContext.queryParams,
      setQueryParams: investigationsUIContext.setQueryParams,
      viewInvestigationButtonClick:
        investigationsUIContext.viewInvestigationButtonClick,
      deleteInvestigationButtonClick:
        investigationsUIContext.deleteInvestigationButtonClick,
    };
  }, [investigationsUIContext]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.investigations }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchInvestigations(investigationsUIProps.queryParams));
  }, [investigationsUIProps.queryParams, dispatch]);

  const columns = [
    {
      dataField: "name",
      text: "نام",
      formatter: NameLinkFormatter,
    },
    {
      dataField: "branchName",
      text: "نام شعبه",
    },
    {
      dataField: "createDate",
      text: "تاریخ بازرسی",
      formatter: DateColumnFormatter,
    },
    {
      dataField: "action",
      text: "عملیات",
      formatter: ActionsColumnFormatter,
      formatExtraData: {
        user,
        deleteInvestigationButtonClick:
          investigationsUIProps.deleteInvestigationButtonClick,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: investigationsUIProps.queryParams.pageSize,
    page: investigationsUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => (
          <Pagination isLoading={listLoading} paginationProps={paginationProps}>
            <BootstrapTable
              wrapperClasses={"table-responsive"}
              bordered={false}
              classes={
                "table table-head-custom table-vertical-header overflow-hidden"
              }
              bootstrap4
              remote
              keyField={"id"}
              data={entities === null ? [] : entities}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                investigationsUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        )}
      </PaginationProvider>
    </>
  );
}
